
  import { Lead } from '@/entities/crm'
  import { Component } from 'vue-property-decorator'
  import Cell from './cell'

@Component
  export default class CreatedByCell extends Cell {
  declare item: Lead
  createdName: string = null

  async mounted () {
    const { item: { createdBy } } = this

    this.createdName = await this.getName(createdBy)
  }

  async getName (createdBy) {
    if (createdBy['x-hasura-user'] === 'system') {
      return 'GENIO'
    }

    const email = createdBy['x-hasura-user-email']

    if (email?.length) {
      const user = await this.fetchData({
        query: { name: 'find', model: 'User' },
        filter: { email: { _eq: email } },
      })

      return user?.[0]?.person?.shortName
    }
  }
  }
